import React from "react";
import getPortalLocData from '../config/loc';


const Hero = ({ title, desc, img }) => (
    <section id="hero">
        <div className="home_banner_img_wrap">
            <img className="home_banner_img" src={img} alt="Banner" title="Banner" />


            <div className="banner_content">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1>{title}</h1>
                            {desc && 
                                <p>{desc}</p>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
); 


export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.jsx